<template>
  <div class="contentBox">
    <div class="mb20 dfx">
      <label for="">服务机构类型：</label>
      <el-radio-group v-model="serviceSearch.institutionType" class="w90" @input="changeRadio">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button v-for="item in typeList" :key="item.id" :label="item.id">{{ item.dictValue }}</el-radio-button>
      </el-radio-group>
    </div>
    <div class="dfx">
      <label for="">机构所在区域：</label>
      <el-radio-group v-model="serviceSearch.institutionalRegion" class="w90" @input="changeRadio">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button v-for="item in regionList" :key="item.id" :label="item.id">{{ item.dictValue }}</el-radio-button>
      </el-radio-group>
    </div>

    <div class="tableBox">
      <JRtable :table-data="serviceTableData" :selection="false" :column="serviceSearchColumn" @page-change="changePages" :pageOptions="pageInfo" size="mini" :border="true" :index="true">
        <template slot="slot_record_img" slot-scope="data">
          <img v-if="data.scope.row.fwtpPath" :src="data.scope.row.fwtpPath" alt="" style="width: 200px; height: 100%; object-fit: contain" />
          <img v-else src="@/assets/servies_img/001.jpg" />
        </template>
        <template slot="slot_record_contact" slot-scope="data">
          <div>{{ data.scope.row.lxr }}<br />{{ data.scope.row.lxdh }}</div>
        </template>
        <template slot="slot_record_tools" slot-scope="data">
          <el-button size="mini" type="primary" @click="lookDetail(data.scope.row.fwid)">查看详情</el-button>
          <el-button size="mini" type="primary" @click="delCollection(data.scope.row.scid)">取消收藏</el-button>
        </template>
      </JRtable>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="75%">
      <div class="services-detail">
        <!-- 中间部分 -->
        <div class="content">
          <div class="cont">
            <div class="all_cont">
              <!-- 左边部分 -->
              <div class="left_cont">
                <!-- 左边的上面商品介绍 -->
                <div class="main-content">
                  <!-- 成交量 -->
                  <div class="volume_box">
                    <div>
                      <div class="num">{{ detailInfo.cjl ? detailInfo.cjl : '0' }}</div>
                      <div class="num_text">成交量</div>
                    </div>
                  </div>
                  <!-- 商品介绍 -->
                  <div class="introduce_box">
                    <div class="img_box">
                      <img v-if="detailInfo.fwtpPath" :src="detailInfo.fwtpPath" alt="" />
                      <img v-else src="@/assets/servies_img/001.jpg" />

                      <div class="but-box">
                        <button v-if="!isShou"><i class="el-icon-star-off"></i>&nbsp;收藏</button>

                        <button v-if="isShou"><i class="el-icon-star-on"></i>&nbsp;已收藏</button>
                        <button @click="handleTousu"><i class="el-icon-warning-outline"></i>&nbsp;投&nbsp;&nbsp;诉</button>
                      </div>
                    </div>
                    <div class="introduce">
                      <div class="in_head">{{ detailInfo.fwmc }}</div>
                      <div class="in_body">
                        <div>
                          参考价格：<span class="priceLabel">¥</span><span class="price">{{ detailInfo.ckjg }}</span>
                        </div>
                        <div>
                          服务简介：<span>{{ detailInfo.fwjj }}</span>
                        </div>
                        <div>
                          联系人：<span>{{ detailInfo.lxr }}</span>
                        </div>
                        <div>
                          联系电话：<span>{{ detailInfo.lxdh }}</span>
                        </div>
                        <div>
                          联系地址：<span>{{ detailInfo.lxdz }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 左边的下面的服务内容 -->

                <div class="service_content">
                  <el-tabs type="card">
                    <el-tab-pane label="服务详情">
                      <div class="service_detail">
                        <div class="detail_head">
                          <div class="head_title">服务内容</div>
                          <div class="head_text">
                            {{ detailInfo.fwnr }}
                          </div>
                        </div>
                        <el-divider></el-divider>

                        <div class="head_title">服务资质</div>
                        <ul class="service_list">
                          <li v-if="detailInfo.fwzzList && !detailInfo.fwzzList.length">暂无资质</li>
                          <li v-else v-for="(i, index) in detailInfo.fwzzList" :key="index">
                            <div class="list_img">
                              <div class="blue_line"></div>

                              <div v-if="i.wjm.substring(i.wjm.lastIndexOf('.') + 1) === 'pdf'"><img src="@/assets/servies_img/file-pdf.png" alt="" /></div>
                              <div v-else><img src="@/assets/servies_img/file-pdf(1).png" alt="" /></div>

                              <span>{{ i.wjm }} </span>
                            </div>
                            <div class="hand">
                              <div>({{ i.wjdx }}KB)</div>
                              <div class="down_load" @click="downloadFile(i.wjdz)">点击查看 <img src="@/assets/servies_img/hand.png" alt="" /></div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </el-tab-pane>

                    <el-tab-pane label="服务评价">
                      <div class="service_evaluate">
                        <div class="evaluate_box">
                          <div class="evaluate_head">
                            <i class="el-icon-s-comment"></i>好评率<span style="color: rgb(255, 197, 61); font-size: 30px">{{ rateData.favorableRate ? rateData.favorableRate : 0 }}</span
                            >%
                          </div>
                          <div>
                            <button v-for="tab in tabList" :key="tab.name" :class="{ active: currentTab === tab.name }" @click="handleTab(tab)">{{ tab.name }}({{ tab.num }})</button>
                          </div>
                        </div>

                        <div class="evaluate_all">
                          <div v-for="(i, k) in rateList" :key="k" class="evaluate_item">
                            <div class="evaluate_person">{{ i.realName }}:</div>
                            <div class="evaluate_body">
                              <div class="evaluate_text">{{ i.pjnr }}</div>
                              <div class="evaluate_star">
                                <div class="evaluate_date">{{ i.pjsj }}</div>
                                <el-rate v-model="i.pjmyd" :max="1" disabled show-score text-color="#ff9900"> </el-rate>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>

              <!-- 右边部分 -->
              <div class="right_cont">
                <div class="org_info">
                  <div class="org_head">机构信息</div>
                  <div class="org_body" @click="$router.push(`/institutionalDetails?jgid=${detailInfo.jgid}`)">
                    <img v-if="detailInfo.jgtpPath" :src="detailInfo.jgtpPath" alt="" />
                    <img v-else src="@/assets/servies_img/001.jpg" />
                    <div class="org_name">{{ detailInfo.jgmc }}</div>
                  </div>
                </div>
                <div class="org_info org_info_2">
                  <div class="org_head">服务推荐</div>
                  <div class="org_all">
                    <div class="org_body org_body-2" v-for="(i, k) in recommendServiesList" :key="k" @click="handleRe(i)">
                      <img v-if="i.fwtpPath" :src="i.fwtpPath" alt="" />
                      <img v-else src="@/assets/servies_img/001.jpg" alt="" />
                      <div class="org_name">{{ i.fwmc }}</div>
                    </div>
                  </div>

                  <div class="page_box">
                    <el-pagination small background layout="prev, pager, next" :total="pageOptions.total" :pager-count="5" @current-change="handleCurrentChange"> </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCollectionList, getDelCollection } from '@/api/enterprise/collection'
import { getCityList } from '@/api'
import { getServiesDetail, getRecommendServiesList, tousu, getQueryEvaluate, shoucangDetail, cancelShoucangServies, shoucangServies } from '@/api/servies/servies'
import JRtable from '@/components/Table'
import { mapGetters } from 'vuex'

export default {
  name: 'Collection',
  components: {
    JRtable
  },
  computed: {
    ...mapGetters(['tyshxydm'])
  },
  data() {
    return {
      dialogVisible: false,
      serviceSearch: {
        institutionType: '',
        institutionalRegion: ''
      },
      serviceTableData: [],
      serviceSearchColumn: [
        {
          label: '',
          prop: 'img',
          align: 'center',
          slot: 'slot_record_img'
        },
        {
          label: '服务名称',
          prop: 'fwmc',
          align: 'center'
        },
        {
          label: '联系人/联系方式',
          prop: 'lxr',
          align: 'center',
          slot: 'slot_record_contact'
        },
        {
          label: '服务简介',
          prop: 'fwjj',
          align: 'center'
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          slot: 'slot_record_tools'
        }
      ],

      // 机构详情数据
      currentTab: 'Tab1',
      tabList: [
        {
          name: '全部',
          num: '0'
        },
        {
          name: '五星',
          num: '0'
        },
        {
          name: '四星',
          num: '0'
        },
        {
          name: '三星',
          num: '0'
        },
        {
          name: '二星',
          num: '0'
        },
        {
          name: '一星',
          num: '0'
        }
      ],
      value: 3.7,
      activeName: 'first',
      pageInfo: {
        limit: 10,
        page: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50]
      },
      detailInfo: {},
      recommendServiesList: [],

      // 服务机构类型
      typeList: [],
      // 机构所在区域
      regionList: [],
      pageOptions: {
        page: 1,
        size: 6,
        total: 0
      },

      rateData: {}, //好评率
      rateList: [],
      isShou: false,
      scid: ''
    }
  },
  created() {
    this.getOrgTypeList()
    this.initList()
  },
  // mounted() {
  //   console.log(this.tyshxydm)
  // },
  methods: {
    // 收藏列表
    initList() {
      // console.log(this.serviceSearch)
      const params = {
        page: this.pageInfo.page,
        size: this.pageInfo.limit,
        tyshxydm: this.tyshxydm,
        areaCode: this.serviceSearch.institutionalRegion,
        fwlx: this.serviceSearch.institutionType
      }
      getCollectionList(params).then((res) => {
        const { pages, size, total, records } = res.data
        this.pageInfo.limit = size
        this.pageInfo.page = pages
        this.pageInfo.total = total
        this.serviceTableData = records
      })
    },
    // 收藏
    async handleShoucang() {
      if (!localStorage.getItem('webInternetToken')) {
        this.$message.error('请先登录')
        return
      }
      // 调接口
      const result = await shoucangServies({ scyh: this.$store.state.user.tyshxydm, fwid: this.$route.query.fwid })
      if (result.code === 200) {
        this.$message.success('收藏成功')
        this.isShou = !this.isShou
      }
    },
    // 取消收藏
    async cancelShoucang() {
      if (!localStorage.getItem('webInternetToken')) {
        this.$message.error('请先登录')
        return
      }

      // 调接口
      const result = await cancelShoucangServies({ scid: this.scid })
      if (result.code === 200) {
        this.$message.success('取消收藏成功')
        this.isShou = !this.isShou
      }
    },
    // 翻页
    changePages(page) {
      this.pageInfo.page = page.page
      this.initList()
    },
    // 服务详情
    async lookDetail(id) {
      const params = {
        fwid: id
      }
      await getServiesDetail(params, true).then((res) => {
        if (res.code === 200) {
          this.detailInfo = res.data
          this.dialogVisible = true
          this.getRecommendServiesList()
        }
      })

      const result = await shoucangDetail({ tyshxydm: this.$store.state.user.tyshxydm, fwid: id })

      this.isShou = result.data && result.data.scid ? 1 : 0

      this.scid = result.data && result.data.scid

      // 查询评价
      this.handleQueryEvaluate(id)
    },
    async getRecommendServiesList() {
      // 获取推荐列表
      const result = await getRecommendServiesList({ ...this.pageOptions })

      this.recommendServiesList = result.data.records || []
      this.pageOptions.total = result.data.total
    },
    handleCurrentChange(val) {
      this.pageOptions.page = val
      this.getRecommendServiesList()
    },
    // 取消收藏
    delCollection(id) {
      const params = {
        scid: id
      }
      getDelCollection(params).then((res) => {
        if (res.code === 200) {
          this.initList()
          this.$message({
            type: 'success',
            message: '取消成功'
          })
        }
      })
    },
    // 投诉弹框
    handleTousu() {
      this.$prompt('请输入投诉说明', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false
      })
        .then(async ({ value }) => {
          // 投诉
          if (!localStorage.getItem('webInternetToken')) {
            this.$message.error('请先登录')
            return
          }

          const result = await tousu({ fwid: this.detailInfo.fwid, jgid: this.detailInfo.jgid, tsyh: this.$store.state.user.tyshxydm, tssm: value })
          if (result.code === 200) {
            this.$message.success('投诉成功')
          }

          // this.getServiesList()
        })
        .catch(() => {})
    },
    // 获取字典数据
    async getOrgTypeList() {
      const result = await getCityList({ codes: 'DIM_FWFL' })
      const qyResult = await getCityList({ codes: '420000' })
      this.typeList = result.data
      this.regionList = qyResult.data
    },
    changeRadio() {
      this.initList()
    },
    downloadFile(file) {
      console.log(file)
    },

    // 查询评价
    async handleQueryEvaluate(fwid) {
      const result = await getQueryEvaluate({ fwid })
      this.rateData = result.data
      this.tabList[0].num = (this.rateData.allList && this.rateData.allList.length) || 0
      this.tabList[1].num = (this.rateData.fiveList && this.rateData.fiveList.length) || 0
      this.tabList[2].num = (this.rateData.fourList && this.rateData.fourList.length) || 0
      this.tabList[3].num = (this.rateData.threeList && this.rateData.threeList.length) || 0
      this.tabList[4].num = (this.rateData.twoList && this.rateData.twoList.length) || 0
      this.tabList[5].num = (this.rateData.oneList && this.rateData.oneList.length) || 0
      this.rateList = this.rateData.allList
    },
    // 点击评价星星
    handleTab(tab) {
      this.currentTab = tab.name
      if (tab.name === '全部') {
        this.rateList = this.rateData.allList
      } else if (tab.name === '五星') {
        this.rateList = this.rateData.fiveList
      } else if (tab.name === '四星') {
        this.rateList = this.rateData.fourList
      } else if (tab.name === '三星') {
        this.rateList = this.rateData.threeList
      } else if (tab.name === '二星') {
        this.rateList = this.rateData.twoList
      } else if (tab.name === '一星') {
        this.rateList = this.rateData.oneList
      }
    },
    handleRe(row) {
      this.$router.push(`/serviesDetail?fwid=${row.fwid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.contentBox {
  width: 100%;
  height: 100%;
  .tableBox {
    margin-top: 25px;
  }
}
.dfx {
  display: flex;
  text-align: left;
  label {
    color: #000;
  }
}
::v-deep .el-radio-button__inner {
  padding: 5px 12px;
  font-family: SourceHanSansCN Normal;
  font-weight: 400;
  font-size: 14px;
  color: #00000099;
  text-align: center;
  border: none;
  box-sizing: border-box;
  border-radius: 2px !important;
}
::v-deep .el-radio-button {
  margin-right: 17px;
  margin-bottom: 10px;
}

::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #2968ff;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-left: none;
}
::v-deep .el-radio-button__inner:hover {
  background: #f2f6fa;
  color: #2968ff;
}
</style>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin-top: 20px;
  margin-bottom: 40px;
}
.services-detail {
  background-color: rgba(247, 248, 249, 1);
  // min-height: 100vh;
}
.header-content {
  width: 100%;
  height: 320px;
  background: url('../../../assets/images/banner_fwjg.png') 50% 0% no-repeat;
  background-size: 100% 100%;
  margin-top: 80px;
  .logo {
    width: 100%;

    height: 100%;
  }
  .header-nav {
    position: absolute;
    left: 360px;
    top: 208px;

    .line {
      width: 60px;
      height: 10px;
      background: #ffffffe6;
    }
    .tittle {
      margin-top: 30px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 36px;
      color: #ffffffe6;
    }
  }
}

.content {
  width: 100%;
  margin-bottom: 23px;
  background-color: rgba(247, 248, 249, 1);
  .cont {
    width: 1400px;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 1);
    padding: 20px 100px;
    box-sizing: border-box;
  }
  .breadcrumb {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
  }
  .active {
    color: #00000066;
  }
  .all_cont {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
    .left_cont {
      width: 900px;
      .main-content {
        position: relative;
        .volume_box {
          position: absolute;
          top: 0;
          right: 0;
          width: 80px;
          height: 80px;
          background: rgba(41, 104, 255, 0.1);
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          text-align: center;
          padding-top: 20px;
          //   line-height: 80px;
          box-sizing: border-box;

          .num {
            font-weight: 500;
            font-size: 24px;
            color: #2968ff;
          }
          .num_text {
            font-weight: 400;
            font-size: 16px;
            color: #666666;
          }
        }
        .img_box {
          width: 212px;
          height: 212px;
          border: 1.67px solid #eeeeee;
          border-radius: 8px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
          .but-box {
            display: flex;
            justify-content: space-between;
            button {
              width: 100px;
              height: 40px;
              background: #ffffff;
              border: 1px solid rgba(0, 0, 0, 0.15);
              border-radius: 2px;
            }
            .el-icon-star-on {
              color: rgba(255, 197, 61, 1);
            }
          }
        }
        .introduce {
          width: 661px;
          font-family: PingFangSC-SNaNpxibold;
          .in_head {
            font-weight: 600;
            font-size: 24px;
            color: rgba(0, 0, 0, 0.9);
          }
          .in_body {
            font-size: 14px;
            font-weight: 400;
            margin-top: 30px;
            text-align: left;

            div {
              color: rgba(0, 0, 0, 0.6);
              margin-bottom: 12px;
            }
            span {
              color: rgba(0, 0, 0, 0.9);
            }
            .price,
            .priceLabel {
              color: rgb(227, 77, 89);
              font-size: 30px;
              font-family: DINAlternate;
              font-weight: 700;
              line-height: 0;
              letter-spacing: 0;
            }
            .priceLabel {
              font-size: 20px;
            }
          }
        }
        .introduce_box {
          display: flex;

          justify-content: space-between;
        }
      }
      .service_content {
        margin-top: 67px;

        .service_detail {
          width: 899px;
          height: 416px;
          border: 1px solid #dfdfdf;
          padding: 20px 30px;
          box-sizing: border-box;
          .head_title {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 20px;
            color: rgba(0, 0, 0, 0.9);
            margin-bottom: 10px;
          }
          .head_text {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.9);
            text-align: left;
          }
        }

        .service_list {
          li {
            width: 837px;
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            position: relative;
            :before {
              width: 4px;
              height: 50px;
              background: #2968ff;
              position: absolute;
            }
          }

          li:hover {
            background: rgba(88, 134, 244, 0.06);
            .blue_line {
              background: #2968ff;
            }
          }
          .blue_line {
            width: 4px;
            height: 50px;
            background: #ffffff00;
            margin-right: 20px;
          }

          .list_img {
            display: flex;
            align-items: center;

            img {
              vertical-align: sub;
            }
          }

          .hand {
            display: flex;
            align-items: center;
            img {
              vertical-align: sub;
            }
            .down_load {
              margin-left: 20px;
              font-weight: 400;
              font-family: PingFangSC;
              font-size: 16px;
              color: #2968ff;
            }
          }
        }
      }
      .service_evaluate {
        button {
          width: 100px;
          height: 40px;
          background: #ffffff;
          border: none;
        }
        .active {
          /* 这里是Tab1的激活样式 */
          background-color: rgba(255, 197, 61, 1);
          color: white;
        }
        .evaluate_box {
          display: flex;
          justify-content: space-between;
        }
        .evaluate_head {
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 20px;
          color: #2968ff;
        }
        .evaluate_item {
          display: flex;
          min-height: 250px;
          margin-top: 20px;

          .evaluate_body {
            margin-left: 20px;
            .evaluate_text {
              width: 500px;
              padding: 10px 20px;
              min-height: 200px;
              border: 1px solid #dfdfdf;
            }
          }
          .evaluate_star {
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }

    .right_cont {
      width: 281px;
      height: 810px;

      .org_info {
        width: 281px;
        height: 124px;
        border: 1px solid #dfdfdf;
        border-radius: 4px;
        cursor: pointer;
        .org_head {
          width: 281px;
          height: 54px;
          line-height: 54px;
          background: rgba(41, 104, 255, 0.1);
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          padding-left: 20px;
          box-sizing: border-box;
        }
        img {
          width: 50px;
          height: 50px;
          border: 1px solid #dfdfdf;
          border-radius: 4px;
        }
        .org_body {
          display: flex;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 10px;
          box-sizing: border-box;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9);
          .org_name {
            margin-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-align: left;
          }
          .line {
            width: 261px;
            height: 1px;
            border: 1px solid #dfdfdf;
          }
        }
      }
      .org_info_2 {
        height: 650px;
        margin-top: 20px;
      }
      .org_all {
        padding: 0 20px;
        box-sizing: border-box;
      }
      .org_body-2 {
        padding-top: 20px !important;
        padding-bottom: 10px;
        padding-left: 0px !important;
        padding-right: 0px !important;
        border-bottom: 1px solid #dfdfdf;
      }
      .page_box {
        margin-top: 40px;
        text-align: center;
      }
    }
  }
}

::v-deep {
  .el-tabs__item {
    color: #b4b4b4;
    font-weight: bolder;
    width: 107px;
    height: 40px;
    font-weight: 400;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    background: #ececec;
    padding: 0;
    // &:hover {
    //   color: #e6e6e6;
    //   background-color: rgba(1, 89, 141, 1);
    //   text-align: center;
    // }
  }

  .el-tabs__nav {
    float: none;
    border: none !important;
    border-left-color: #ffffff00 !important;
    border-bottom: 2px solid rgba(41, 104, 255, 1) !important;
    border-top: none !important;
    text-align: left;

    // text-align: center;
  }

  .el-tabs__item.is-active {
    color: #e6e6e6;
    background-color: rgba(41, 104, 255, 1);
    text-align: center;
    border-bottom-color: #fff0 !important;
  }
  .el-tabs__active-bar {
    background-color: transparent !important;
  }
  .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
}
::v-deep .el-table--mini {
  max-height: 580px;
  overflow-y: scroll;
}
</style>
